import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * Keeps the square shape of NG-ZORRO buttons whose only content is an `<i>` icon
 * (Font Awesome, or `<i nz-icon>`).
 *
 * Up to NG-ZORRO 13, `nz-button` added `ant-btn-icon-only` to a button with `<i>`
 * children and no text or `<span>`. From 14 it only counts a `<span>` holding an
 * `<svg>`, so these buttons got the padding of a text button and could wrap to a
 * new line. This applies the NG-ZORRO 13 rule after the button's own check, when
 * its text nodes are already wrapped in `<span>`.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- it must match NG-ZORRO's own nz-button attribute, so the literax prefix cannot apply
  selector: 'button[nz-button], a[nz-button]',
})
export class IconOnlyButtonDirective implements AfterViewInit {
  constructor(private element: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const nodes = Array.from(this.element.nativeElement.childNodes);
    const hasIcon = nodes.some((node) => node.nodeName === 'I');
    const hasContent = nodes.some(
      (node) => node.nodeName === '#text' || node.nodeName === 'SPAN'
    );
    if (hasIcon && !hasContent) {
      this.renderer.addClass(this.element.nativeElement, 'ant-btn-icon-only');
    }
  }
}
